import {
  BooleanField,
  DateField,
  ImageField,
  NumberField,
  ResourceProps,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
} from 'react-admin';
import React, { FC } from 'react';

import styled from 'styled-components';

const UsersShow: FC<ResourceProps> = (props) => {
  return (
    <Show title="Пользователь" {...props}>
      <TabbedShowLayout>
        <Tab label="О пользователе">
          <StyledImageField label="Аватар" source="profile.avatarUrl" />
          <TextField source="id" />
          <TextField label="Имя" source="profile.name" />
          <TextField label="Фамилия" source="profile.surname" />
          <TextField label="Никнейм" source="nickname" />
          <TextField label="Телефон" source="phone" />
          <BooleanField label="Заблокирован" source="isBlocked" />
        </Tab>
        <Tab label="О профиле">
          <TextField label="Краткое описание профиля" source="profile.shortDescription" />
          <TextField label="Полное описание профиля" source="profile.fullDescription" />
          <BooleanField label="Галочка" source="profile.verified" />
          <NumberField label="Приоритет" source="profile.priority" />
          <DateField locales="rus" label="Создан" source="profile.createdAt" />
          <DateField locales="rus" label="Обновлен" source="profile.2022-08-26T03:46:07.791Z" />
        </Tab>
        <Tab label="Контакты">
          <TextField label="Телефон" source="phone" />
          <TextField label="Адрес электронной почты" source="email" />
          <TextField label="Вебсайт" source="website" />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default UsersShow;

const StyledImageField = styled(ImageField)`
  img {
    width: 150px;
    height: 150px;
    border-radius: 75px;
  }
`;
